import { render, staticRenderFns } from "./bidui-result.vue?vue&type=template&id=cb338f36&"
import script from "./bidui-result.vue?vue&type=script&lang=ts&"
export * from "./bidui-result.vue?vue&type=script&lang=ts&"
import style0 from "./bidui-result.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports